// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import common from "@store/Themes/common/styleguide/components/forms/checkbox";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const checkbox: Styleguide["checkbox"] = {
    defaultProps: {
        ...common?.defaultProps,
        color: "secondary",
        css: css`
            ${common?.defaultProps?.css}

            &:hover {
                span[role="checkbox"]:not([aria-disabled="true"]) {
                    border-color: ${getColor("secondary")};
                }
            }

            span[role="checkbox"] {
                padding: ${pxToRem(2)};
                border: ${pxToRem(1)} solid ${getColor("common.borderDark")};
                cursor: pointer;

                &[aria-checked="true"],
                &[aria-checked="mixed"] {
                    border-radius: ${pxToRem(3)};
                }

                &[aria-disabled="true"] {
                    padding: ${pxToRem(3)};
                    color: ${getColor("common.background")};
                    background-color: ${getColor("common.disabled")};
                    border-color: ${getColor("common.disabled")};

                    &:hover {
                        border: ${pxToRem(2)} solid ${getColor("common.disabled")};
                        cursor: not-allowed;
                    }

                    & + label:hover {
                        cursor: not-allowed;
                    }

                    svg {
                        stroke: ${getColor("common.background")};
                    }
                }

                &:focus {
                    box-shadow: none;
                    outline-color: ${getProp("theme.focus.color")};
                    outline-style: ${getProp("theme.focus.style")};
                    outline-width: ${pxToRem(1)};
                }

                + label {
                    margin: 0 0 0 0.5em;
                    cursor: pointer;
                    &::before {
                        flex-shrink: 0;
                    }
                }
            }
        `,
    },
};

export default checkbox;
